import { adminColors } from '../../theme/adminTheme';

// Shared by StudentsPage.js (list rows) and StudentDrawer.js (header chip)
// — kept in its own module rather than exported from either so the two
// don't end up in a circular import (StudentsPage renders StudentDrawer).

// Derived, not a real backend field: GET /api/admin/users has no
// `status`/`access_granted` filter and no "invited" concept of its own —
// only `access_granted` (a real column) and `last_active` (derived from
// the max message timestamp). "Invited" here means exactly "has platform
// access but has never sent a message" — a reasonable stand-in given what
// the API actually returns, not a real invitation-tracking state (that
// lives in the separate Invitations table this endpoint doesn't join).
export function deriveStudentStatus(user) {
  if (user?.access_granted === false) return 'no_access';
  if (!user?.last_active) return 'invited';
  return 'active';
}

// Same visual language InvitesPage's own invite-status chips use (light
// tint + saturated text, no MUI `color` enum) — "Invited" reuses the exact
// indigo pairing InvitesPage uses for its "Pending" chip.
export const STATUS_META = {
  active: { label: 'Active', bg: '#e8f5e9', color: '#2e7d32' },
  invited: { label: 'Invited', bg: adminColors.accentLight, color: adminColors.accentDark },
  // #dc2626 (this app's default danger red, see adminTheme.js's
  // palette.error.main) only measures ~4.4:1 against this chip's light
  // #fef2f2 background at the small size these chips render at — below the
  // 4.5:1 AA floor. #991b1b is the same red family (it's
  // SafetyFlagsView.SEVERITY_CONFIG.high's chip text color, the app's one
  // other "danger red on light red" pairing) and clears 6.8:1.
  no_access: { label: 'No access', bg: '#fef2f2', color: '#991b1b' },
};

export function formatLastActive(iso) {
  if (!iso) return 'Never signed in';
  const formatted = new Date(iso).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  return `Last active ${formatted}`;
}
